<template>
  <div class="w-full flex flex-col">
    <div v-if="!noDivider" class="w-full h-0 border-t border-border-normal mt-4" />
    <BaseText type="label" size="md" class="px-1 text-text-muted" :class="{'mt-2.5': !noDivider}">
      Query Parameters
    </BaseText>
    <div class="w-full grid mt-2 rounded-lg border border-border-normal"
    style="grid-template-columns: 0.5fr 1fr;">
      <div class="w-full px-3 py-1.5 border-r border-border-normal">
        <BaseText type="body" size="sm" class="text-text-muted">
          Key
        </BaseText>
      </div>
      <div class="w-full px-3 py-1.5">
        <BaseText type="body" size="sm" class="text-text-muted">
          Value
        </BaseText>
      </div>
      <div v-for="(kv, index) in queryParams" :key="`query-param-${index}`" class="w-full px-3 py-1.5 border-t border-border-normal"
      :class="{'border-r': index % 2 === 0}">
        <BaseText type="body" size="sm" class="text-text-normal">
          {{ kv }}
        </BaseText>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RequestQueryParamsGrid',
  props: {
    queryParams: {
      type: Array,
      required: true
    },
    noDivider: {
      type: Boolean,
      default: false
    }
  }
}
</script>